import { useSelector } from 'react-redux'
import { Link, NavLink, useLocation } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// Light weight icons for inactive state
import { 
  faGraduationCap as faGraduationCapLight, 
  faHospitalUser as faHospitalUserLight, 
  faBuildingColumns as faBuildingColumnsLight,
  faHeartPulse as faHeartPulseLight
} from '@fortawesome/pro-light-svg-icons'
// Solid weight icons for active state
import { 
  faGraduationCap as faGraduationCapSolid, 
  faHospitalUser as faHospitalUserSolid, 
  faBuildingColumns as faBuildingColumnsSolid,
  faHeartPulse as faHeartPulseSolid,
  faHouseChimneyUser as faHouseChimneyUserSolid
} from '@fortawesome/pro-solid-svg-icons'
//import AppActions from '~/actions/app'
import Profile from './Profile'
//import Notifications from './Notifications'
import Login from './Login'
import { UserRoles } from '../../services/config'
//import SearchBox from './Search'

// Helper function to get icon based on active state
const getIconByState = (iconName, isActive) => {
  const iconMap = {
    'heart-pulse': isActive ? faHeartPulseSolid : faHeartPulseLight,
    'graduation-cap': isActive ? faGraduationCapSolid : faGraduationCapLight,
    'hospital-user': isActive ? faHospitalUserSolid : faHospitalUserLight,
    'building-columns': isActive ? faBuildingColumnsSolid : faBuildingColumnsLight,
  };
  return iconMap[iconName];
};

const useRoutes = () => {
  const roleId = useSelector((state) => state.app.app_role_id);
  const isEditor =  roleId <= UserRoles.MANAGER;
  const loggedIn = useSelector(state => state.app.token);


  // This stuff has been majorly cut back for MVP release
  return [
    ... (loggedIn ? [
          //{ icon: 'heart-pulse', label: 'Score', path: `/hcm/report-checkout/individual` },
          //{ icon: 'graduation-cap', label: 'Learn', path: '/hcm/training-feed' },
          //{ icon: 'hospital-user', label: 'Health Plan', path: `/hcm/report-careers/employee/individual/view` },
          //... (isEditor ? [{
          //    icon: 'building-columns',
          //    label: 'Library',
          //    path: '/library',
          //    }]
          //    : []
          //)
      ]
      : []
    )
  ]
}

const Header = () => {
    const loggedIn = useSelector((state) => state.app.token);
    const location = useLocation();
    const routes = useRoutes(loggedIn);

    return (
        <div className="ds-navbar logged">
          <nav className="p-0 navbar navbar-expand navbar-light">
            <div className="navbar-brand">
                <Link to="/library/training" style={{ textDecoration: 'none'}}>
                    {/*<FontAwesomeIcon 
                      icon={faHouseChimneyUserSolid} 
                      size="2xl" 
                      style={{ lineHeight: '25px', color: 'white' }}
                    />
                    <span style={{ color: 'white' }}>SOVEREIGN </span>
                    <img className="p-0 ms-0 desktop-only" src="/images/ds-logo.svg" alt="DS Logo" />
                    <img className="p-0 ms-0 mobile-screen" src="/images/ds-logo-small.svg" alt="DS Logo Small" /> */}
                    <img className="p-0 ms-0 desktop-only" src="/images/tula/LiveTula-Hrz-White.png" alt="Ola Logo" style={{ height: '35px' }} />
                </Link>
            </div>
            <button 
              aria-controls="ds-navbar" 
              type="button" 
              aria-label="Toggle navigation" 
              className="navbar-toggler collapsed"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            <div className="navbar-collapse collapse" id="ds-navbar">
              <div className="navbar-nav d-flex align-items-center">
                {routes.map((nav, idx) => {
                  
                  const isActive = location.pathname.includes(nav.path.split('?')[0]);

                  return (
                    <NavLink
                      key={idx}
                      to={nav.path}
                      className={isActive ? 'nav-link active' : 'nav-link'}
                      style={{ height: '45px' }}
                    >
                      <FontAwesomeIcon 
                        icon={getIconByState(nav.icon, isActive)} 
                        size="2xl" 
                        style={{ lineHeight: '25px' }}
                      />
                      <span>{nav.label}</span>
                    </NavLink>
                    )
                  })
                }
              
                
                {/* Mobile menu */}
                <div className="nav-link mobile-screen nav-item">
                  <i className="far fa-ellipsis-h" style={{ color: 'white', fontSize: '22px' }}></i>
                  <span className="dsl-w14">Menu</span>
                </div>
              </div>
              
              <div className="controls ms-auto ps-0 ps-sm-4">
                {/* <SearchBox /> */}
                {loggedIn ? (
                  <div className="d-h-center">
                    {/* <Notifications /> */}
                    <Profile />
                  </div>
                ) : (
                  <Login />
                )}
              </div>
            </div>      
        </nav>
      </div>
    )
  }


export default Header;
